import { Injectable } from '@angular/core';
import { AngularFireAuth } from '@angular/fire/auth';
import { AngularFirestore, Query } from '@angular/fire/firestore';
import * as firebase from 'firebase';
import { FirebaseAuthService } from './firebaseauth.service';
import { UserDetail } from '@app/interface/auth.user';
import { StudiesService } from './studies.service';
import { Observable, of } from 'rxjs';
import { EmailTemplate } from '@app/interface/emailTemplate';
import { switchMap } from 'rxjs/operators';

@Injectable({
  providedIn: 'root',
})
export class EmailTemplatesService {
  constructor(
    private store: AngularFirestore,
    private afAuth: AngularFireAuth,
    private authService: FirebaseAuthService,
    private studiesService: StudiesService
  ) {}

  public addEmailTemplate(emailTemplate: EmailTemplate, studyDetail: any) {
    return this.authService.getUser().pipe(
      switchMap((user: UserDetail) => {
        emailTemplate.uuid = this.store.createId();
        emailTemplate.createdBy = user.email;
        emailTemplate.studyName = studyDetail.studyName;
        emailTemplate.studyRef = studyDetail.docRef;
        emailTemplate.studyId = studyDetail.uuid;
        emailTemplate.createdAt = firebase.default.firestore.Timestamp.now();
        emailTemplate.updatedAt = firebase.default.firestore.Timestamp.now();
        emailTemplate.updatedBy = user.email;
        emailTemplate.isDelete = false;
        return this.store
          .collection<EmailTemplate>('email-template')
          .doc(emailTemplate.uuid)
          .set(emailTemplate, { merge: true });
      })
    );
  }

  public updateEmailTemplate(emailTemplate: EmailTemplate) {
    return this.authService.getUser().pipe(
      switchMap((user: UserDetail) => {
        emailTemplate.updatedAt = firebase.default.firestore.Timestamp.now();
        emailTemplate.updatedBy = user.email;
        return this.store.collection<EmailTemplate>('email-template').doc(emailTemplate.uuid).update(emailTemplate);
      })
    );
  }

  public async deleteEmailTemplate(templateID: string) {
    return this.store.collection('email-template').doc(templateID).delete();
  }

  public cloneEmailTemplate(emailTemplate: EmailTemplate) {
    return this.authService.getUser().pipe(
      switchMap((user: UserDetail) => {
        emailTemplate.uuid = this.store.createId();
        emailTemplate.createdBy = user.email;
        emailTemplate.templateName = `Clone ${emailTemplate.templateName}`;
        emailTemplate.createdAt = firebase.default.firestore.Timestamp.now();
        emailTemplate.updatedAt = firebase.default.firestore.Timestamp.now();
        emailTemplate.updatedBy = user.email;
        return this.store
          .collection<EmailTemplate>('email-template')
          .doc(emailTemplate.uuid)
          .set(emailTemplate, { merge: true });
      })
    );
  }

  public getEmailTemplatesByStudyId(): Observable<any> {
    let studyId = this.studiesService.getStudyId();
    console.log(studyId);
    return this.afAuth.authState.pipe(
      switchMap((user: firebase.default.User) => {
        if (user && studyId) {
          return this.store
            .collection<EmailTemplate>('email-template', (ref) => {
              let query: Query = ref;
              return query.where('studyId', '==', studyId).where('isDelete', '==', false).orderBy('createdAt', 'desc');
            })
            .valueChanges();
        } else {
          return of([]);
        }
      })
    );
  }
}
